import { Button as DefaultButton } from '@material-ui/core';
import { styled } from '@material-ui/core/styles';
import { spacing } from '@material-ui/system';

// Applies the spacing system to the material UI Button
const Button = styled(DefaultButton)(spacing);

export default Button;